<template>
  <div>
    <slot />
    <v-snackbar
      v-model="$store.state.core.snackbar.status"
      :color="$store.state.core.snackbar.color"
      :timeout="$store.state.core.snackbar.timeout"
    >
      {{ $store.state.core.snackbar.text }}
      <v-btn dark flat @click="$store.state.core.snackbar.status = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "NoSidebar",
};
</script>

<style scoped></style>
